import * as CONSTANTS from '../../Constants/ActionTypes'
import _ from 'lodash'

let initialState = {
  loading: false,
  currentSiteID: '',
}

export default (state = initialState, action) => {
  switch (action.type) {
    case CONSTANTS.SET_CURRENT_SITE_ID:
      return {
        ...state,
        currentSiteID: action.payload,
      }
    default:
      return state
  }
}
